document.documentElement.addEventListener('mdm-multiscroll-rendered', () => {
	// We style the page conditionally based on when mutliscroll initializes
	// to avoid layout shifts impacting Google PageSpeed score.
	document.body.classList.add('mdm-ms-rendered')
})
